<template>
  <div class="bg-[var(--bg)]">
    <Notifications />
    <!-- Dark overlay -->
    <div
      v-if="showSidebar"
      class="fixed inset-0 bg-red-200 opacity-50 z-30"
      @click="toggleSidebar"
      @keydown="toggleSidebar"
    ></div>
    <!-- menu -->
    <div
      v-click-outside="clickOutside"
      class="
        w-full fixed
        z-40
        -mt-2
        mb-8
      "
    >
      <NavBar/>
      <!-- sidebar -->
      <Sidebar />
    </div>
    <!-- content -->
    <div
      class="pt-16"
      :class="{
        'blocker': showSidebar,
      }"
    >
      <div class="min-h-screen">
        <router-view />
      </div>
    </div>
    <!-- footer -->
    <DigiFooter
      :isLight="isLight"
      :isAuth="isAuth"
      :usersLink="`${VUE_APP_DG_USERS_APP}`"
      :showSidebar="showSidebar"
    />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { DigiFooter } from '@digi-io/digi-ui';

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));

const store = useStore();

const showSidebar = computed(() => store.state.sidebar);
const isLight = computed(() => store.state.theme.theme === 'light');

const currentYear = ref(new Date().getFullYear());

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

function toggleSidebar() {
  store.commit('toggleSidebar');
}

</script>

<style scoped>
.blocker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.9); /* Change the alpha value for darkness */
  z-index: 20; /* Ensure it's above the sidebar */
}
</style>
